import { render, staticRenderFns } from "./AnchorImg.vue?vue&type=template&id=7c24cae3&scoped=true&"
import script from "./AnchorImg.vue?vue&type=script&lang=js&"
export * from "./AnchorImg.vue?vue&type=script&lang=js&"
import style0 from "./AnchorImg.vue?vue&type=style&index=0&id=7c24cae3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c24cae3",
  null
  
)

export default component.exports